export default "__VITE_ASSET__BZPMDYdn__"